"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.validateTransform = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const consolidateErrors_1 = require("./consolidateErrors");
const errorUtils_1 = require("./errorUtils");
const helpers_1 = require("./helpers");
const typeguards_1 = require("./typeguards");
const utils_1 = require("./utils");
// excel/csv have a header row and are 1 based arrays, so adjust for our 0 based rowData
const STANDARD_ROW_INDEX_OFFSET = 2;
const consolidateDuplicateValuesErrors = (unknownErrors) => {
    return (0, consolidateErrors_1.consolidateErrors)(unknownErrors, (error) => error.field, // Group by field
    (error) => ({
        firstRow: String(error.firstRow),
        duplicateRow: String(error.duplicateRow),
        value: error.value,
    }), // Map to row data
    (field) => `Duplicate values found for field [${field}]`);
};
const consolidateMissingDataErrors = (unknownErrors) => {
    return (0, consolidateErrors_1.consolidateErrors)(unknownErrors, (error) => error.field, // Group by field
    (error) => ({
        row: String(error.row),
        value: error.value,
    }), // Map to row data
    (field) => `Tape missing value for field [${field}]`);
};
const consolidateToStructuredErrors = (errors) => {
    const missingDataErrors = errors.filter((error) => error.type === 'joinMissingDataError');
    const duplicateValuesErrors = errors.filter((error) => error.type === 'joinDuplicateDataError');
    // we want to consolidate the errors if there are too many of those.
    return [
        ...consolidateMissingDataErrors(missingDataErrors),
        ...consolidateDuplicateValuesErrors(duplicateValuesErrors),
    ];
};
const checkJoinTransformOp = (transformation) => {
    const errors = [];
    const srcJoinOnBaseField = _.find(transformation.srcDataTape.baseFields, (bf) => bf.field === transformation.joinOnField);
    // check that joinOnField exists in srcDataTape basefields
    if (srcJoinOnBaseField === undefined) {
        errors.push({
            type: 'metadataValidation',
            message: `Source DataTape baseFields is missing joinOnField - checkJoinTransformOp: ${transformation.joinOnField}`,
        });
    }
    // check that srcDataTape joinOnField basefield is required
    if (srcJoinOnBaseField !== undefined &&
        !(0, typeguards_1.isRequiredBaseFieldConfig)(srcJoinOnBaseField)) {
        errors.push({
            type: 'metadataValidation',
            message: `Source DataTape joinOnField baseField must be a required field - checkJoinTransformOp: ${transformation.joinOnField}`,
        });
    }
    const joinJoinOnBaseField = _.find(transformation.joinDataTape.baseFields, (bf) => bf.field === transformation.joinOnField);
    // check that joinOnField exists in joinDataTape basefields
    if (joinJoinOnBaseField === undefined) {
        errors.push({
            type: 'metadataValidation',
            message: `Join DataTape baseFields is missing joinOnField - checkJoinTransformOp: ${transformation.joinOnField}`,
        });
    }
    // check that srcDataTape joinOnField basefield is required
    if (joinJoinOnBaseField !== undefined &&
        !(0, typeguards_1.isRequiredBaseFieldConfig)(joinJoinOnBaseField)) {
        errors.push({
            type: 'metadataValidation',
            message: `Join DataTape joinOnField baseField must be a required field - checkJoinTransformOp: ${transformation.joinOnField}`,
        });
    }
    // check that srcDataTape and joinDataTape joinOnField basefield are the same type
    if (srcJoinOnBaseField !== undefined &&
        joinJoinOnBaseField !== undefined &&
        srcJoinOnBaseField?.type !== joinJoinOnBaseField.type) {
        errors.push({
            type: 'metadataValidation',
            message: `Source DataTape and Join DataTape joinOnField baseFields must be the same type - checkJoinTransformOp: ${transformation.joinOnField} ${srcJoinOnBaseField.type} ${joinJoinOnBaseField.type}`,
        });
    }
    // check that all joinFields exist in joinData basefields
    const missingJoinFields = _.filter(transformation.joinFields, (jf) => !_.some(transformation.joinDataTape.baseFields, (bf) => bf.field === jf.field));
    if (missingJoinFields.length !== 0) {
        errors.push({
            type: 'metadataValidation',
            message: `Join DataTape missing joinFields - checkJoinTransformOp: ${missingJoinFields
                .map((jf) => jf.field)
                .join(',')}`,
        });
    }
    const srcFields = transformation.srcDataTape.baseFields.map((bf) => bf.field);
    // remove joinOnField from srcFields
    _.pull(srcFields, transformation.joinOnField);
    // check that all srcFields and joinFields are unique
    const dupeFields = _.chain([
        ...srcFields,
        ...transformation.joinFields.map((jf) => jf.field),
    ])
        .groupBy()
        .pickBy((f) => f.length > 1)
        .keys()
        .value();
    if (dupeFields.length !== 0) {
        errors.push({
            type: 'metadataValidation',
            message: `Duplicate sourceFields and joinFields - checkJoinTransformOp: ${dupeFields.join(',')}`,
        });
    }
    if (!transformation.errorOnMissingJoinRow) {
        // check that all joinFields conform to join dataTape baseField configurations
        const joinBaseFieldsMap = _.keyBy(transformation.joinDataTape.baseFields, 'field');
        transformation.joinFields.forEach((jf) => {
            const baseField = joinBaseFieldsMap[jf.field];
            if (!baseField) {
                (0, common_1.debugLog)('Missing joinField in joinDataTape: available joinBaseFieldsMap:', joinBaseFieldsMap);
                // missing field. Do not process further.
                // we will catch missing fields error later.
                return;
            }
            // check if the baseField is required, if so, the joinField must have a default to
            if ((0, typeguards_1.isRequiredBaseFieldConfig)(baseField) && jf.defaultTo === undefined) {
                errors.push({
                    type: 'metadataValidation',
                    message: `Join BaseField is required, must have defaultTo value for joinField - checkJoinTransformOp: ${jf.field}`,
                });
            }
            // if there is a defaultTo value, it must conform to the baseField configuration
            if (jf.defaultTo !== undefined) {
                // ensure that a boolean has the correct externalBoolean. Only true and false allowed.
                if ((0, typeguards_1.isBooleanBaseFieldConfig)(baseField) &&
                    !['true', 'false'].includes(jf.defaultTo)) {
                    errors.push({
                        type: 'metadataValidation',
                        message: `Must have valid defaultTo value (true or false) for boolean joinField [field:${baseField.field}], [found:${jf.defaultTo}]`,
                    });
                    return;
                }
                try {
                    (0, helpers_1.getSanitizedDataTapeField)(baseField, jf.defaultTo, true);
                }
                catch (err) {
                    if ((0, typeguards_1.isInvalidField)(err)) {
                        errors.push({
                            type: 'metadataValidation',
                            message: `Must have valid defaultTo value for joinField - checkJoinTransformOp: ${jf.field} ${err.expectedType} ${jf.defaultTo}`,
                        });
                    }
                    else {
                        errors.push({
                            type: 'metadataValidation',
                            message: `Unexpected row sanitization error - checkJoinTransformOp: ${jf.field} ${err.message}`,
                        });
                    }
                }
            }
        });
    }
    return errors;
};
const validateTransform = (transformation) => {
    const errors = checkJoinTransformOp(transformation);
    if (errors.length > 0) {
        return {
            isValid: false,
            errors,
        };
    }
    const joinBaseFieldsMap = _.keyBy(transformation.joinDataTape.baseFields, 'field');
    const baseFields = [
        ...transformation.srcDataTape.baseFields,
        ..._.map(transformation.joinFields, (jf) => joinBaseFieldsMap[jf.field]),
    ];
    return {
        isValid: true,
        data: {
            baseFields,
            delimiter: ',',
            sanitizedFieldNames: false,
        },
    };
};
exports.validateTransform = validateTransform;
const checkJoinTransformData = ({ transformation, joinData, }) => {
    const errors = [];
    const field = transformation.joinOnField;
    // Map to track the first occurrence of each value
    const valueMap = new Map();
    joinData.forEach((item, rowIndex) => {
        const value = String(item[field]);
        if (valueMap.has(value)) {
            // If value is already encountered, log an error
            errors.push({
                type: 'joinDuplicateDataError',
                field,
                firstRow: valueMap.get(value) + 1,
                duplicateRow: rowIndex + 1,
                value,
            });
        }
        else {
            // Record the first occurrence of the value
            valueMap.set(value, rowIndex);
        }
    });
    return errors;
};
const performTransform = async ({ dataTapeBuffers, transformation, csvParser, }) => {
    (0, common_1.finleyAssert)(dataTapeBuffers.length === 2, 'Join:Expected 2 data tape buffers');
    const [srcDataTapeBuffer, joinDataTapeBuffer] = dataTapeBuffers;
    try {
        const srcDelimiter = transformation.srcDataTape.delimiter;
        const joinDelimiter = transformation.joinDataTape.delimiter;
        const tapeDefinitionResult = (0, exports.validateTransform)(transformation);
        (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, 'Join:Invalid tape definition');
        (0, common_1.finleyAssert)(tapeDefinitionResult.data, 'Join:Invalid tape definition data');
        // get the outputDataTape early in the process to error out if necessary
        const outputDataTape = tapeDefinitionResult.data;
        const [srcCsvOutput, joinCsvOutput] = await Promise.all([
            common_1.csvConversion.finleyBufferToCsvArray({
                buffer: srcDataTapeBuffer,
                delimiter: srcDelimiter,
                csvParser,
            }),
            common_1.csvConversion.finleyBufferToCsvArray({
                buffer: joinDataTapeBuffer,
                delimiter: joinDelimiter,
                csvParser,
            }),
        ]);
        const srcData = srcCsvOutput.csvArray;
        const joinData = joinCsvOutput.csvArray;
        const joinOnField = transformation.joinOnField;
        const errorOnMissingJoinRow = transformation.errorOnMissingJoinRow;
        // ensure the data is joinable
        const joinDataErrors = checkJoinTransformData({
            transformation,
            joinData,
        });
        // set joinOnDefault once for reuse in map
        let joinOnDefault;
        if (!errorOnMissingJoinRow) {
            const defaultedJoinFields = transformation.joinFields.filter(({ defaultTo }) => defaultTo !== undefined);
            const joinBaseFieldsMap = _.keyBy(transformation.joinDataTape.baseFields, 'field');
            const joinFieldsMap = _.keyBy(defaultedJoinFields, 'field');
            joinOnDefault = _.reduce(joinFieldsMap, (acc, jf, prop) => ({
                ...acc,
                [prop]: (0, helpers_1.getSanitizedDataTapeField)(joinBaseFieldsMap[prop], jf.defaultTo, true),
            }), {});
        }
        const srcFields = transformation.srcDataTape.baseFields.map((f) => f.field);
        const joinFields = transformation.joinFields.map((jf) => jf.field);
        const data = srcData.map((src, index) => {
            // check if joinOn matches in src and join data
            let joinMatch = _.find(joinData, (jd) => src[joinOnField] === jd[joinOnField]);
            if (joinMatch === undefined && errorOnMissingJoinRow) {
                joinDataErrors.push({
                    type: 'joinMissingDataError',
                    // excel/csv have a header row and are 1 based arrays, so adjust for our 0 based rowData
                    row: index + STANDARD_ROW_INDEX_OFFSET,
                    value: String(src[joinOnField]),
                    field: joinOnField,
                });
                return {};
            }
            // if a match does not exist, if required with a default, set to that value
            if (joinMatch === undefined && joinOnDefault !== undefined) {
                joinMatch = joinOnDefault;
            }
            return {
                ..._.pick(src, srcFields),
                ..._.pick(joinMatch, joinFields),
            };
        });
        // if any errors exist, entire run is invalid
        if (joinDataErrors.length !== 0) {
            return {
                isValid: false,
                errors: consolidateToStructuredErrors(joinDataErrors),
            };
        }
        const outputBuffer = (0, utils_1.rowDataToCsv)(data, outputDataTape);
        return {
            isValid: true,
            data: {
                outputBuffer,
            },
            supplementals: [],
        };
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'join: ');
    }
};
exports.transformOperation = {
    operation: 'join',
    validateTransform: exports.validateTransform,
    performTransform,
};
//# sourceMappingURL=join-transform.js.map